import { httpClient } from "@services/api/httpClient";

interface GetOfferTagParams {
  search?: string
  targetCountry?: string
  categoryId?: number
}

export async function getAllOfferTag({search, targetCountry, categoryId }: GetOfferTagParams) {
  const response = await httpClient.get("/offer-tag", {
    params: { search, targetCountry, categoryId }
  });
  return response.data;
}